import PageHero from "@/components/layout/PageHero";
import SEO from "@/components/layout/SEO";
import FeatureList from "@/components/layout/FeatureList";
import EnglishExamCrossSell from "@/components/layout/EnglishExamCrossSell";
import EntryExamCrossSell from "@/components/layout/EntryExamCrossSell";
import EligibilitySection from "@/components/home/EligibilitySection";
import FinalCTA from "@/components/home/FinalCTA";
import { IMG, BOOKING_URLS } from "@/lib/content";

const ITEMS = [
  { title: "Choose the right university", body: "Match programs to your field, budget and long-term plan — based on real institutional insight." },
  { title: "Understand entry requirements", body: "Grades, English scores, documents, apostille — by country and by program." },
  { title: "Affordable paths", body: "Public and private universities, scholarships, and lower-cost cities where living goes further." },
  { title: "Straightforward visa basics", body: "What you'll need, when, and how to avoid the common first-time mistakes." },
];

export default function Bachelor() {
  return (
    <div data-testid="page-bachelor">
      <SEO
        title="Bachelor degrees in Poland — admissions guidance"
        description="A guided path through Polish universities for international Bachelor's applicants: program selection, entry requirements, documents, visa, and arrival."
        path="/bachelor"
      />
      <PageHero
        overline="Bachelor in Poland"
        title={<>Bachelor in Poland — from <span className="italic text-[#D7141A]">first question</span> to first semester.</>}
        subtitle="A guided path through universities, requirements, documents and visa — built for international students who want clarity, not a brochure."
        image={IMG.campus}
        ctaPrimary={{ to: BOOKING_URLS.bachelor, label: "Book Consultation" }}
        ctaSecondary={{ to: "/free-resources", label: "Free Starter Guide" }}
      />
      <FeatureList
        overline="What we help with"
        title="A clear Bachelor path, without the guesswork."
        intro="We focus on what actually moves your application forward — and on removing the noise that doesn't."
        items={ITEMS}
      />
      <EnglishExamCrossSell
        level="B2"
        context="Most Bachelor programs in Poland require"
        testId="bachelor-english-cross-sell"
      />
      <EntryExamCrossSell
        context="Most Bachelor programs in Poland include"
        note="Required for non-OECD applicants — many universities require everyone."
        testId="bachelor-entry-exam-cross-sell"
      />
      <EligibilitySection />
      <FinalCTA />
    </div>
  );
}
